import { createFileRoute } from '@tanstack/react-router'
import { AgentConfigPage } from '@/features/agents/components/agent-config/agent-config-page'

export const Route = createFileRoute('/_authenticated/agents/$id/edit')({
  component: AgentConfigPage,
})
